import React, { FormEvent, useEffect, useState } from "react";
import {
  AsideContainer,
  Box,
  Button,
  Container,
  FormBox,
  Input,
  LoadingFlex,
  MarketingSide,
  Wrapper,
  Heading,
  HStack,
  LoginContent,
  InputBase,
  Label,
  ButtonStyled,
  ImageLogo,
  Header
} from "./styles";
import logoUx from "../../../../assets/logo-uxdoc.svg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../../../hooks/auth";
import PuffLoader from "react-spinners/PuffLoader";
import computerIcon from "../../assets/reset-password2.png";

import { toast, ToastContainer } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Ripple } from "react-spinners-css";
import DecorationBackground from "../../../login/components/DecorationBackground";
import api from "../../../../services/api";
import LoadingEditor from "../../../editor/components/LoadingEditor";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";

interface ProfileProps {
  first_name: string;
  last_name: string;
  email: string;
  old_password: string;
  password: string;
  password_confirmation: string;
  document: string;
  is_individual: boolean;
  phone: string;
}

interface SubmitProps {
  oldPassword: string;
  password: string;
  confirmPassword: string;
}

const ChangePassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { createdAccount, setCreatedAccount } = useAuth();
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [redirect, setRedirect] = useState(false);
  const [profileUser, setProfileUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    old_password: "",
    password: "",
    password_confirmation: "",
    document: "",
    is_individual: false,
    phone: ""
  } as ProfileProps);

  const { signIn } = useAuth();
  let navigate = useNavigate();

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      scale: 1.05,
      transition: {
        delayChildren: 0.5,
        type: "spring",
        duration: 1,
        stiffness: 200,
        staggerDirection: -1
      }
    }
  };

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 1.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  const schema = yup.object({
    oldPassword: yup.string().min(6).required("Senha antiga obrigatoria"),
    password: yup.string().min(6).required("Insira nova senha"),
    confirmPassword: yup.string().min(6).required(`Insira confirmacao de senha`)
  });

  function toastMessageCreatedAccount() {
    toast.success("Sua conta foi criada com sucesso!");
  }

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SubmitProps>({
    resolver: yupResolver(schema)
  });

  const onSubmit: SubmitHandler<SubmitProps> = async data => {
    if (data.oldPassword === "") {
      toast.error("Insira a senha.");
      return;
    }

    if (data.password !== data.confirmPassword) {
      toast.error("As senhas nao sao iguais.");
      return;
    }

    try {
      setLoading(true);
      setProfileUser(state => {
        let cloneState = { ...state };
        cloneState.old_password = data.oldPassword;
        cloneState.password = data.password;
        cloneState.password_confirmation = data.confirmPassword;
        return cloneState;
      });

      let myChanges = {
        first_name: profileUser.first_name,
        last_name: profileUser.last_name,
        email: profileUser.email,
        old_password: data.oldPassword,
        password: data.password,
        password_confirmation: data.confirmPassword,
        document: profileUser.document,
        is_individual: profileUser.is_individual,
        phone: profileUser.phone
      };

      console.log(myChanges, "pra api");

      const response = await api.put("profile", myChanges);

      toast.success("Nova senha atualizada, redirecionando para perfil...");
      setLoading(false);
      setTimeout(() => {
        setRedirect(true);
      }, 1000);
    } catch (error) {
      console.log("222", error.response.data);
      setLoading(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (redirect) {
      window.open("/perfil");
    }
  }, [redirect]);

  useEffect(() => {
    const autoLoad = async () => {
      const response = await api.get("profile");
      const { user, people, contacts } = response.data;

      console.log(people, "people");

      setProfileUser({
        ...profileUser,
        first_name: people.first_name,
        last_name: people.last_name,
        email: user.email,
        document: people.document,
        is_individual: people.is_individual,
        phone: contacts.phone
      });

      setLoadingScreen(false);
    };

    autoLoad();
  }, []);

  console.log(profileUser, "oi profile");

  return (
    <>
      {loadingScreen ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <LoadingFlex>
            {/* <LoadingEditor /> */}
            <ContractAnimation />
          </LoadingFlex>
        </div>
      ) : (
        <Container>
          <ToastContainer position="top-left" />
          <AsideContainer>
            <LoginContent
              initial="hidden"
              animate="show"
              variants={container}
              as={motion.form}
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="hero-login-div">
                {/* <img className="hero-login-img" src={logoUX3} /> */}

                {/* <ImageLogo src={logoUX2} /> */}
                <Header>Alterar senha</Header>
              </div>

              <span>Altere a sua senha para proteger a sua conta.</span>

              <InputBase
                className="force-margin"
                type="password"
                placeholder="Senha antiga"
                {...register("oldPassword")}
              />

              <InputBase
                type="password"
                placeholder="Nova senha"
                {...register("password")}
                className="force-margin"
              />
              {errors.password?.message && (
                <p className="error-validation">
                  {errors.password?.message ===
                  "password must be at least 6 characters"
                    ? "Senha deve ter no mínimo 6 caracteres"
                    : "email invalido."}
                </p>
              )}

              <InputBase
                type="password"
                placeholder="Confirme nova senha"
                {...register("confirmPassword")}
                className="force-margin"
              />

              <ButtonStyled type="submit">
                {loading ? (
                  <LoadingFlex>
                    <LoadingEditor color="#fff" width={20} height={20} />
                  </LoadingFlex>
                ) : (
                  `Salvar`
                )}
              </ButtonStyled>
            </LoginContent>
          </AsideContainer>
          <DecorationBackground />
          <MarketingSide>
            <HStack>
              <img src={computerIcon} className="img-background" />
            </HStack>
          </MarketingSide>
        </Container>
      )}
    </>
  );
};

export default ChangePassword;
